import { Button, Row, Col } from "antd";
import Modal from "antd/lib/modal/Modal";
import { toGetPurshaseOrder, toPrintPurshaseOrder } from "../APIs";
import { PrinterOutlined } from "@ant-design/icons";
import { toConvertDate } from "../../../Utils/Utils";
import { useEffect, useState } from "react";
import cookie from "react-cookies";

const PurshaseorderModal = ({ AppStore, purshaseorder, onClose }) => {
  const [purshase, setPurshase] = useState(null);
  useEffect(() => {
    if (null != purshaseorder) {
      toGetPurshaseOrder(purshaseorder.id).then((res) => {
        setPurshase(res);
      });
    }
  }, [purshaseorder]);
  const printPurshaseorder = () => {
    toPrintPurshaseOrder(purshaseorder.id);
  };

  const close = () => {
    onClose();
    setPurshase(null);
  };

  return (
    <Modal
      className="smtv-modal modal-large"
      visible={purshaseorder != null}
      onCancel={close}
      title="Details"
      footer={[
        <Button key="close" onClick={onClose}>
          Fermer
        </Button>,
        <Button
          key="submit"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={printPurshaseorder}
        >
          Imprimer
        </Button>,
      ]}
    >
      {purshaseorder && (
        <>
          <h1 style={{ textAlign: "center" }}>Bon de commande</h1>
          <Row>
            <Col className="info-box" md={11}>
              <p>
                <b>Ref</b> : {purshaseorder.s__ref}
              </p>
              <p>
                <b>Date</b> : {toConvertDate(purshaseorder.createdDate)}
              </p>
              <p>
                <b>Chargé Fournisseur</b> :{" "}
                {purshaseorder.createdBy && purshaseorder.createdBy}
              </p>
            </Col>
            <Col className="info-box" md={12}>
              <h1>Fournisseur</h1>
              <p>
                <b>Nom</b> : {purshaseorder.providerName}
              </p>
              <p>
                <b>Tel</b> :{" "}
              </p>
            </Col>
          </Row>
          <h1 style={{ textAlign: "center", marginTop: "20px" }}>Articles</h1>
          <table className="ant-table" style={{ width: "100%" }}>
            <thead className="ant-table-thead">
              <tr>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  Ref
                </th>
                <th className="ant-table-cell">Désignation</th>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  P U HT
                </th>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  P U TTC
                </th>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  Qte
                </th>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  Remise
                </th>
                <th className="ant-table-cell" style={{ width: "5%" }}>
                  TVA
                </th>
                <th className="ant-table-cell" style={{ width: "8%" }}>
                  Prix Total
                </th>
              </tr>
            </thead>
            <tbody className="ant-table-tbody">
              {purshase &&
                purshase.purshase__orderItems &&
                purshase.purshase__orderItems.map((item) => (
                  <tr>
                    <td className="ant-table-cell" style={{ width: "8%" }}>
                      {item.article.s__reference}
                    </td>
                    <td className="ant-table-cell">
                      {item.article.s__firstTitle}
                    </td>
                    <td className="ant-table-cell" style={{ width: "12%" }}>
                      {item.d__unitPriceHT.toFixed(3)}
                    </td>
                    <td className="ant-table-cell" style={{ width: "12%" }}>
                      {item.d__unitPriceTTC.toFixed(3)}
                    </td>
                    <td className="ant-table-cell" style={{ width: "10%" }}>
                      {item.d__quantity}
                    </td>
                    <td className="ant-table-cell" style={{ width: "10%" }}>
                      {item.d__discount} %
                    </td>
                    <td className="ant-table-cell" style={{ width: "5%" }}>
                      {item.d__tva} %
                    </td>
                    <td className="ant-table-cell" style={{ width: "12%" }}>
                      {item.d__total.toFixed(3)} Dt
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div style={{ textAlign: "right", marginTop: 20 }}>
            <div
              style={{
                display: "inline-block",
                textAlign: "right",
              }}
            >
              <p>
                <b>Tota HT</b> :{" "}
                {(purshaseorder.total - purshaseorder.tva).toFixed(3)} DT
              </p>
              <p>
                <b>TVA</b> : {purshaseorder.tva.toFixed(3)} DT
              </p>
              <p>
                <b>Remise Totale</b> : {purshaseorder.discount} %
              </p>
              <p>
                <b>Net à Payer</b> : {purshaseorder.total.toFixed(3)} DT
              </p>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default PurshaseorderModal;
